import React, { useEffect, useState } from "react";
import { Car, Loader2 } from "lucide-react";
import { api } from "@/lib/api";

// In-memory cache so the same vehicle description isn't refetched on every poll.
const cache = {};

export default function VehicleImage({ desc, className = "", iconSize = 24, testID }) {
  const key = (desc || "").trim().toLowerCase();
  const [uri, setUri] = useState(key ? cache[key] ?? null : null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!key) return;
    if (cache[key] !== undefined) { setUri(cache[key]); return; }
    let cancelled = false;
    setLoading(true);
    api(`/vehicle-image?desc=${encodeURIComponent(desc)}`)
      .then((d) => { if (!cancelled) { cache[key] = d.image || null; setUri(d.image || null); } })
      .catch(() => { if (!cancelled) { cache[key] = null; setUri(null); } })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [key, desc]);

  return (
    <div className={`flex shrink-0 items-center justify-center overflow-hidden bg-accent ${className}`} data-testid={testID}>
      {uri ? (
        <img src={uri} alt={desc || "vehicle"} className="h-full w-full object-cover" />
      ) : loading ? (
        <Loader2 className="animate-spin text-brand-600" style={{ width: iconSize, height: iconSize }} />
      ) : (
        <Car className="text-brand-600" style={{ width: iconSize, height: iconSize }} />
      )}
    </div>
  );
}
